import { COURSE_ASSISTANT_TEACHER_ROLE, COURSE_TEACHER_ROLE, COURSE_PARTICIPANT_ROLE } from '../../i18n/keyConstants';

export function getEmployeeCourseRole(course, id, t) {
    const courseTeacher = course.teachers.find((teacher) => teacher.coaEmpId?.toLowerCase() === id.toLowerCase());
    const extraTeacher = !courseTeacher && course.lectures.some((lecture) => lecture.teachers.some((teacher) => teacher.coaEmpId?.toLowerCase() === id.toLowerCase()));
    return extraTeacher ? t(COURSE_ASSISTANT_TEACHER_ROLE) : courseTeacher ? t(COURSE_TEACHER_ROLE) : t(COURSE_PARTICIPANT_ROLE);
}

export function findBookingByEmpId(course, id, t) {
    if (getEmployeeCourseRole(course, id, t) === t(COURSE_TEACHER_ROLE)) {
        return null;
    } else {
        return course?.bookings?.find(({ coaEmpId }) => coaEmpId.toLowerCase() === id.toLowerCase());
    }
}